export const isPrintableKey = (event: React.KeyboardEvent): boolean =>
  event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;

/**
 * Finds the <td> at the given grid coordinate inside `tableEl` and returns
 * the first input/textarea inside it, or null if none exists.
 */
export const getCellTextInput = (
  tableEl: HTMLTableElement,
  coord: { rowIndex: number; colIndex: number }
): HTMLInputElement | HTMLTextAreaElement | null => {
  const rows = tableEl.querySelectorAll("tbody tr");
  const row = rows[coord.rowIndex];
  if (!row) {
    return null;
  }
  const cells = row.querySelectorAll("td");
  const cell = cells[coord.colIndex];
  if (!cell) {
    return null;
  }
  return cell.querySelector<HTMLInputElement | HTMLTextAreaElement>("input, textarea");
};

export const isInsideDialog = (element: HTMLElement): boolean => {
  let current = element?.parentElement;

  while (current) {
    if (current.getAttribute("role") === "dialog") {
      return true;
    }

    if (current.tagName === "HTML") {
      return false;
    }

    current = current.parentElement;
  }

  return false;
};
